export default "__VITE_ASSET__TquK$8Bt__"